import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { HttpErrorHandlerService, HandleError } from '../shared/http-error-handler.service';

import { ForuscareService } from '../foruscare/foruscare.service';
import { catchError } from 'rxjs/operators';
import { PaymentConfig } from 'src/app/models/paymentConfig';
import { Package } from 'src/app/models/package';
import { validityExntension } from 'src/app/models/validityextension';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private handleError: HandleError;
  constructor(public http: HttpClient, public fourscareService: ForuscareService, httpErrorHandler: HttpErrorHandlerService) {
    this.handleError = httpErrorHandler.createHandleError('Payment Service');

  }

  savePaymentConfig(paymentConfigData: PaymentConfig): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/priceConfig", paymentConfigData)
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }
  updatePaymentConfig(paymentConfigData: PaymentConfig): Observable<any> {
    return this.http.put<any>(this.fourscareService.baseAuthURL() + "/priceConfig/" + paymentConfigData.id, paymentConfigData)
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }
  changeAccountSubscriptionType(accountId, subscriptionType): Observable<any> {
    return this.http.put<any>(this.fourscareService.baseAuthURL() + "/accounts/" + accountId + "/" + subscriptionType, '')
      .pipe(
        catchError(this.handleError('account subscription data updation'))
      )
  }
  saveFrameworkSettings(settingsObj): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/framework/saveFrameworkSettings",settingsObj)
      .pipe(
        catchError(this.handleError('save framework settings'))
      )
  }
  saveFrameworkSettingsByApplication(settingsObj,applicationName:String): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/framework/saveFrameworkSettingsByApplication/"+applicationName,settingsObj)
      .pipe(
        catchError(this.handleError('save framework settings'))
      )
  }
  getFrameworkSettings(): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/framework/getFrameworkSettings")
      .pipe(
        catchError(this.handleError('get framework settings'))
      )
  }
  getFrameworkSettingsByApplication(applicationName:String): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/framework/getFrameworkSettings/"+applicationName)
      .pipe(
        catchError(this.handleError('get framework settings'))
      )
  }

  savePackageDetails(packageDetails: Package): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/organization/purchase/reportPackage", packageDetails)
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }
  updatePackageDetails(packageDetails: Package, reportPackageId): Observable<any> {
    return this.http.put<any>(this.fourscareService.baseAuthURL() + "/organization/purchase/reportPackage/" + reportPackageId, packageDetails)
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }
  updatePackageStatus(packageStatus, reportPackageId): Observable<any> {
    return this.http.put<any>(this.fourscareService.baseAuthURL() + "/organization/purchase/reportPackage/" + reportPackageId + "/" + packageStatus, '')
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }
  getPackageDetailsByFilter(filterType): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/organization/purchase/reportPackage/package/" + filterType)
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }
  getPackageDetails(): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/organization/purchase/reportPackage")
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }
  getPackageDetailsPaging(count, offset): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/organization/purchase/reportPackage?count=" + count + "&offset=" + offset)
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }
  getTransactionHistoryByTransactionId(transactionId, accountId, orgId): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/payment/getPaymentHistoryByTransactionId/" + accountId + "/" + orgId + "/" + transactionId)
      .pipe(
        catchError(this.handleError('get transaction history by user transaction history'))
      )
  }
  getTransactionHistoryByUserNameOrEmail(filtervalue, accountId, orgId,offset,limit): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/payment/getPaymentHistoryByUserEmail/" + accountId + "/" + orgId + "/" + filtervalue+"?limit="+limit+"&offset="+offset)
      .pipe(
        catchError(this.handleError('get transaction history by user name or email'))
      )
  }
  getSpectacleTransactionHistory(request:any,transactionStatus:any,offset:any,limit:any): Observable<any> {
    return this.http.post<any>(this.fourscareService.spectacleURL + "/dashboard/getTransactionHistory/"+transactionStatus+"?offset="+offset+"&limit="+limit,request)
      .pipe(
        catchError(this.handleError('get spectacle transaction history'))
      )
  }
  getPackageDetailsById(pkgId): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/organization/purchase/reportPackage/" + pkgId)
      .pipe(
        catchError(this.handleError('payment data updation'))
      )
  }

  getPaymentConfig(accountId): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/priceConfig/price/config/" + accountId)
      .pipe(
        catchError(this.handleError('payment data retrieve'))
      )
  }

  getRefundHistoryByTransactionId(transactionId) {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/payment/refund/history/" + transactionId)
      .pipe(
        catchError(this.handleError('refund history by transaction id'))
      )
  }

  getDatewisePayments(accountId, orgId, startDate, endDate): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/payment/" + startDate + "/" + endDate + "/" + accountId + "/" + orgId)
      .pipe(
        catchError(this.handleError('payment statistics datewise'))
      )
  }

  getPaymentsByAccount(accountId, orgId, startDate, endDate): Observable<any> {
    var endPoint = this.fourscareService.baseAdminURL() + "/payment/account/" + startDate + "/" + endDate + "/" + accountId + "/" + orgId;
    if (accountId != null && accountId != undefined) {
      endPoint = this.fourscareService.baseAdminURL() + "/payment/account/" + startDate + "/" + endDate + "/" + accountId;
    }
    return this.http.get<any>(endPoint)
      .pipe(
        catchError(this.handleError('payment statistics by account'))
      )
  }

  getIncentiveReportsByAccountOrgId(accountId, orgId, startDate, endDate): Observable<any> {
    return this.http.post<any>(this.fourscareService.hostUrl+"/EssilorIncentive/api/IncentiveTransaction/summarize/transactions", {
      startDate: startDate,
      endDate: endDate,
      accountId: accountId,
      orgId: orgId
    })
      .pipe(
        catchError(this.handleError('incentive statistics by account/org'))
      )
  }

  getPaymentsByPackage(accountId, orgId, startDate, endDate): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/payment/package/" + startDate + "/" + endDate + "/" + accountId + "/" + orgId)
      .pipe(
        catchError(this.handleError('payment statistics by account'))
      )
  }

  getPaymentTransactionHistoryDateRangeAndOrg(accountId: any, orgId: any, fromDate: any, toDate: any,application:any,transactionStatus:any,offset:any,limit:any) {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/payment/getPaymentHistoryByAccountAndOrg/" + fromDate + "/" + toDate + "/" + accountId + "/" + orgId+"/"+application+"/"+transactionStatus+"?offset="+offset+"&limit="+limit)
      .pipe(
        catchError(this.handleError('payment transaction history account id and org id'))
      )
  }

  getPackagesSubscribedByAccountAndOrg(accountId: any, orgId: any) {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/subscription/subscribedPackages/" + accountId + "/" + orgId)
      .pipe(
        catchError(this.handleError('pacakges subscribed by account id and org id'))
      )
  }

  getPackagesSubscribedByAccountAndOrgPaging(accountId: any, orgId: any, count, offset, currentStatus) {
    let offSet = 0;
    if(offset){
      offSet = offset;
    }
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/subscription/subscribedPackages/" + accountId + "/" + orgId+"?count=" + count + "&offset=" + offSet + '&currentStatus=' + currentStatus)
      .pipe(
        catchError(this.handleError('pacakges subscribed by account id and org id'))
      )
  }

  updatePackageValidity(extensionInfo: validityExntension) {
    return this.http.put<any>(this.fourscareService.baseAuthURL() + "/subscription/updateSubscriptionValidity", extensionInfo)
      .pipe(
        catchError(this.handleError('extend package validity'))
      )
  }

  getPackageExtensionHistory(subscriptionId: any) {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/subscription/getSubscriptionValidityExtensionDetails/" + subscriptionId)
      .pipe(
        catchError(this.handleError('list package extension history'))
      )
  }

  intiateRefund(refundDetails: any) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/admin/payment/refund", refundDetails)
      .pipe(
        catchError(this.handleError('refunt initiate with transaction id and subscriptions'))
      )
  }

  fetchOfflinePayments() {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/admin/payment/offline")
      .pipe(
        catchError(this.handleError('Error fetching offline payment records'))
      )
  }

  fetchOfflinePaymentsPaging(count, offset) {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/admin/payment/offline?count=" + count + "&offset=" + offset)
      .pipe(
        catchError(this.handleError('Error fetching offline payment records'))
      )
  }

  getAllAccounts(): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/accounts")
      .pipe(
        catchError(this.handleError('Error fetching prepaid accounts payment records'))
      );
  }

  getAllPrepaidPackages(): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/organization/purchase/reportPackage/prepaid/offlinePackages")
      .pipe(
        catchError(this.handleError('Error fetching prepaid packages'))
      );
  }

  saveOfflinePayment(offlinePaymentPaylod: any) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/subscription/addofflinePayment", offlinePaymentPaylod)
      .pipe(
        catchError(this.handleError('Error saving details'))
      )
  }

  exportOfflineReportXLS(payload) {
    return this.http.post(this.fourscareService.baseAuthURL() + "/admin/payment/exportOfflinePackageStatisticsByCustomFilter", payload, { observe: 'response', responseType: 'blob' }) as any
  }

  fetchDateWiseFilteredOfflinePayments(payload,  offset, count, searchValue, columnName) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/admin/payment/offline/criteria?"+'count='+count+'&offset='+offset+'&searchBy='+searchValue+'&filterBy='+columnName, payload)
      .pipe(
        catchError(this.handleError('Error saving details'))
      )
  }
  updatePaymentStatusByOrderId(payload):Observable<any>{
      return this.http.post<any>(this.fourscareService.baseAuthURL() + "/fhpayment/updatePaymentStatusByOrderId",payload)
      .pipe(
        catchError(this.handleError('Error in updating payment status'))
      )
  }
  getPackagesExpiringByFilter(payload) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + '/subscription/packages/filter', payload)
      .pipe(
        catchError(this.handleError('Error fetching packages expiring'))
      );
  }

  getPackagesExpiringByAccount(payload) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + '/subscription/account/package/filter', payload)
      .pipe(
        catchError(this.handleError('Error fetching packages expiring for account'))
      );
  }

  getSpectacleVendorProviders() {
    return this.http.post<any>(this.fourscareService.customerOnboardingURL + '/onboarding/getSpectacleVendorProviders', {})
      .pipe(
        catchError(this.handleError('Error fetching packages expiring for account'))
      );
  }

  getPackagesbyFilter(count, offset, search, filter,packageType) {
    if(!search){
      search = "";
    }
    if(!filter){
      filter = "";
    }
    if(!offset){
      offset = 0;
    }
    if(!count){
      count = 10;
    }if(!packageType){
      packageType = '';
    }
    return this.http.get<any>(this.fourscareService.baseAuthURL() + '/organization/purchase/reportPackage?count='+count+'&offset='+offset+'&searchBy='+search+'&filterBy='+filter+'&packageType='+packageType, {})
      .pipe(
        catchError(this.handleError('Error fetching packages expiring for account'))
      );
  }

}
